




































































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import Step1 from "../Step1/Step1.vue";
import Step2 from "../Step2/Step2.vue";
import Step3 from "../Step3/Step3.vue";
import Step4 from "../Step4/Step4.vue";
@Component({
    components: { Step1, Step2, Step3, Step4 }
})
export default class StepperHost extends Vue {
    @Prop({ default: 1 }) startStep: number;

    state = +this.startStep;
    @Watch("state") scrollToTop() {
        this.$root.scrollUp();
    }

    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }

    get isCalcCardShown() {
        return [1, 2, 3].includes(this.state) && !this.isFastCalcDisabled;
    }
}
